module.exports = __webpack_public_path__ + "static/kalashtar_1-0246edb985b2c33e862f6e0caecd71f6.png";